import * as GET from './get';
import * as POST from './post';

export default { GET, POST };

export * as AlmanacController from './AlmanacController';
export * as AnsweringOrgController from './AnsweringOrgController';
export * as AnsweringServiceController from './AnsweringServiceController';
export * as AppExternalController from './AppExternalController';
export * as AppointmentController from './AppointmentController';
export * as AuthController from './AuthController';
export * as BrokerBayAdminController from './BrokerBayAdminController';
export * as ContactController from './ContactController';
export * as ContextualChatController from './ContextualChatController';
export * as DuplicateListingController from './DuplicateListingController';
export * as FavoriteController from './FavoriteController';
export * as FeedbackController from './FeedbackController';
export * as FileController from './FileController';
export * as GroupController from './GroupController';
export * as HistoryController from './HistoryController';
export * as ListingController from './ListingController';
export * as LockboxController from './LockboxController';
export * as MailerController from './MailerController';
export * as NotificationController from './NotificationController';
export * as OAuthController from './OAuthController';
export * as OfferController from './OfferController';
export * as OnboardingController from './OnboardingController';
export * as OnboardingPortalController from './OnboardingPortalController';
export * as OrgController from './OrgController';
export * as RetsController from './RetsController';
export * as RetsOpenHouseController from './RetsOpenHouseController';
export * as SecretsController from './SecretsController';
export * as ShowingCalendarController from './ShowingCalendarController';
export * as SupraController from './SupraController';
export * as SupraLockController from './SupraLockController';
export * as TeamController from './TeamController';
export * as UserController from './UserController';
export * as UserSuggestedUpdateController from './UserSuggestedUpdateController';
export * as VirtualTourController from './VirtualTourController';
export * as TableauController from './TableauController';
